import { snackbar } from "@mobiscroll/react5";
import { CANCEL_RAZORPAY_SUBSCRIPTION, CREATE_RAZORPAY_SUBSCRIPTION, FETCH_CURRENT_PLAN_BY_ID, GET_SUB_STATUS, RAZORPAY_PLANS, UPDATE_PLAN, VERIFY_RAZORPAY_SUBSCRIPTION_SIGNATURE } from "src/components/graphql/GraphQLquery";
import { getQuery, getQueryWithParams, postMutation } from "src/components/ApolloConnection/ApolloProviderComponent";

export async function listAllRazorpayPlans() {
    try {
        const response = await getQuery(RAZORPAY_PLANS);
        console.log("razorpay api response-->", response);

        if (
            response &&
            response?.data.listAllRazorpayPlans.statusCode < 300 &&
            response?.data.listAllRazorpayPlans.statusCode >= 200
        ) {
            return response.data.listAllRazorpayPlans.data;
        } else {
            throw new Error(response);
        }
    } catch (e) {
        snackbar({ message: e.message || "Some error occured while fetching plan details. Try again", color: "danger", });
        console.error("Error at add doctor fee: ", e.message);
        return [];
    }
}

export async function createRazorpaySubscription(id) {
    try {
        console.log("createRazorpaySubscription called with id:", id)
        const clinicId = id || sessionStorage.getItem("clinic-id");
        const response = await postMutation(CREATE_RAZORPAY_SUBSCRIPTION, clinicId);

        if (typeof response === "undefined") {
            throw new Error("error", response);
        } else {
            if (
                response.data.createRazorpaySubscription.statusCode < 300 &&
                response.data.createRazorpaySubscription.statusCode >= 200
            ) {
                return response.data.createRazorpaySubscription.data;
            } else {
                throw new Error(response);
            }
        }
    } catch (e) {
        snackbar({
            message: e.message || "Some error occured while creating razorpay subcription. Try again",
            color: "danger",
        });
        console.error("Error creating subscription for clinic: ", e);
        return null;
    }
}

export async function updateProfile(data) {
    try {
        const response = await postMutation(UPDATE_PLAN, data);

        if (typeof response === "undefined") {
            throw new Error("error", response);
        } else {
            if (
                response.data.updateClinic.statusCode < 300 &&
                response.data.updateClinic.statusCode >= 200
            ) {
                return response.data.updateClinic.data;
            } else {
                throw new Error(response);
            }
        }
    } catch (e) {
        snackbar({
            message: e.message || "Some error occured while updating profile. Try again",
            color: "danger",
        });
        console.error("Error at adding selected plan: ", e);
        return null;
    }
}

//cancel existing subscription
export async function cancelRazorpaySubscription(id) {
    try {
        const response = await postMutation(CANCEL_RAZORPAY_SUBSCRIPTION, id);

        if (
            typeof response === "undefined" ||
            response?.errors ||
            !(
                response?.data?.cancelRazorpaySubscription?.statusCode < 300 &&
                response?.data?.cancelRazorpaySubscription?.statusCode >= 200
            )
        ) {
            throw new Error("error", response);
        } else {
            return true;
        }
    } catch (e) {
        snackbar({
            message: e.message || "Some error occured while Cancelling subscription. Try again",
            color: "danger",
        });
        console.error("Error at createRazorpayPlan: ", e);
        return false;
    }
}

// verify razorpay payment signature from backend
export async function verifyRazorpaySubscriptionSignature({ razorpay_subscription_id, razorpay_payment_id, razorpay_signature }) {
    try {
        if (!razorpay_subscription_id || !razorpay_payment_id || !razorpay_signature) {
            console.log("verifyRazorpaySubscriptionSignature: missing fields", {
                razorpay_subscription_id,
                razorpay_payment_id,
                razorpay_signature,
            });
            return false;
        }

        const response = await getQuery(VERIFY_RAZORPAY_SUBSCRIPTION_SIGNATURE, {
            razorpay_subscription_id,
            razorpay_payment_id,
            razorpay_signature,
        }, true);

        if (
            response &&
            response?.data?.verifyRazorpaySubscriptionSignature?.statusCode < 300 &&
            response?.data?.verifyRazorpaySubscriptionSignature?.statusCode >= 200
        ) {
            return response?.data?.verifyRazorpaySubscriptionSignature?.data?.verified === true;
        } else {
            throw new Error(response);
        }
    } catch (e) {
        snackbar({ message: e.message || "Subscription verification failed.", color: "danger", });
        console.error("Error at verify subscription: ", e);
        return false;
    }
}

//get user's subscription status
export async function getUserSubStatus() {
    try {
        const response = await getQueryWithParams(GET_SUB_STATUS);
        if (typeof response === "undefined") {
            throw new Error("error", response);
        } else {
            if (
                response.data.getMyProfile.statusCode < 300 &&
                response.data.getMyProfile.statusCode >= 200
            ) {
                return response.data.getMyProfile.data;

            } else {
                throw new Error(response);
            }
        }
    } catch (e) {
        snackbar({ message: e.message || "Some error occured while fetching Profile. Try again", color: "danger", });
        console.error("Error at fetching profile: ", e);
        return null;
    }
}

//fetch current subscription details
export async function fetchSubscriptionPlanById(id) {
    try {
        const response = await getQueryWithParams(FETCH_CURRENT_PLAN_BY_ID, id);
        let result = response?.data?.fetchSubscriptionPlanById;

        if (typeof response == "undefined" || !(result?.statusCode >= 200 && result?.statusCode <= 300)
        ) {
            throw new Error(result?.message);
        } else {
            if (result?.data) {
                return result?.data;
            } else {
                throw new Error();
            }
        }
    } catch (e) {
        snackbar({ message: e?.message || "Some error occured. Try again", color: "danger", });
        console.error("Error at fetching subscription information ", e);
        return null;
    }
}